import { Directive } from '@angular/core';

@Directive({
  selector: '[appMessageCardTitle]',
  standalone: true,
})
export class MessageCardTitleDirective {}
